import React from 'react';

interface Props {
  children: any;
}

export const PageHeader = (props: Props) => {
  return (
    <div className="rms-heading">
      <h1 style={{ fontSize: '20px' }}>{props.children}</h1>
    </div>
  );
};
